<div class="admin-container">
  <div *ngFor="let column of pictureColumns" class="column">
    <div *ngFor="let picture of column.pictures" class="picture">
      <img
        loading="lazy"
        [ngSrc]="baseUrl + picture.src"
        [width]="picture.width"
        [height]="picture.height"
        [alt]="picture.description"
        (click)="this.fullScreenPicture = picture"
      />
      <div *ngIf="picture.legend" class="legend">{{ picture.legend }}</div>
    </div>
  </div>
</div>

<div
  class="full-screen"
  *ngIf="fullScreenPicture"
  (click)="fullScreenPicture = null"
>
  <div class="picture-container">
    <img
      class="full-screen-image"
      loading="lazy"
      [ngSrc]="baseUrl + fullScreenPicture.src"
      [width]="fullScreenPicture.width"
      [height]="fullScreenPicture.height"
      [alt]="fullScreenPicture.description"
    />
  </div>
</div>
